import TermList from "../AdminTermList";

export default class AdminTermListTimeZone extends TermList {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "time_zone";
  }
}
